import { useApiInfiniteQuery, type Api } from "../../../services/api";

const limit = 20;

export type SearchArticleItem =
  Api["get"]["/webapp/public/articles/search"]["output"]["body"]["docs"][number];

export function useSearchArticlesQuery(
  searchValue: string,
  roomId: string | null,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const trimmed = searchValue.trim();
  const isEnabled = enabled && trimmed.length > 0;

  const query = useApiInfiniteQuery(
    "/webapp/public/articles/search",
    isEnabled
      ? {
          query: {
            limit,
            search: trimmed,
            scoring: "relevant",
            adminPanel: false,
            impactFactorMoreThan: 0,
            roomId: roomId === null ? undefined : roomId,
            meshResolver: true,
          },
        }
      : false
  );

  return {
    articles: query.state === "success" ? query.docs : [],
    total: query.state === "success" ? (query.total ?? 0) : 0,
    isLoading: query.state === "pending",
    isFetching: query.state === "idle" ? false : query.isFetching,
    hasNextPage: query.state === "success" && query.hasNextPage,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
  };
}
